import { ensureAllUserProjectsFetched } from '@common/modules/projects/stores/projects.actions'
import { getCurrentWorkspace, getWorkspacesByUserId } from '@common/modules/workspaces/stores/workspaces.actions'
import type { Workspace } from '@common/modules/workspaces/types'

/**
 * After `getCurrentUser`, runs workspaces load, user-wide projects prefetch, and regional init in parallel.
 * Resolves the current workspace only after regional identity is available (for lastUsedWorkspaceId).
 */
export async function runInitialAppDataParallelBatch(
  initializeUserRegionalData: () => Promise<void>
): Promise<{ workspace: Workspace | null }> {
  const [, workspace] = await Promise.all([
    ensureAllUserProjectsFetched(),
    (async (): Promise<Workspace | null> => {
      await Promise.all([getWorkspacesByUserId(), initializeUserRegionalData()])
      return getCurrentWorkspace()
    })(),
  ])
  return { workspace }
}
